export const LOOKALIKE_AUDIENCE = 'lookalikeAudience';
export const SHARE_ACCOUNTS = 'shareAccounts';
